<template>
  <div>
    <!-- Android / Chrome: native prompt -->
    <v-btn
      color="primary"
      depressed
      @click="installApp"
      block
      v-if="!isIOS && deferredPrompt"
      >
      <v-icon left>mdi-download</v-icon>
      Install The App
    </v-btn>

    <!-- iOS: manual instructions -->
    <v-alert
      type="info"
      dense
      outlined
      class="mt-2"
      v-if="isIOS && !isStandalone"
    >
      Tap <strong>Share</strong>
      <v-icon small color="success" class="mx-1">mdi-export-variant</v-icon>
      then <strong>Add to Home Screen</strong>
      <v-icon small color="success" class="mx-1">mdi-plus-box-outline</v-icon>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "InstallButton",

  data() {
    return {
      deferredPrompt: null,
      canInstall: false,
      isIOS: /iphone|ipad|ipod/i.test(window.navigator.userAgent),
      isStandalone:
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true,
    };
  },

  mounted() {
    window.addEventListener("beforeinstallprompt", this.onBeforeInstallPrompt);
    window.addEventListener("appinstalled", this.onAppInstalled);
  },

  beforeDestroy() {
    window.removeEventListener("beforeinstallprompt", this.onBeforeInstallPrompt);
    window.removeEventListener("appinstalled", this.onAppInstalled);
  },

  methods: {
    onBeforeInstallPrompt(e) {
      e.preventDefault();
      this.deferredPrompt = e;
      this.canInstall = true;
    },

    onAppInstalled() {
      this.canInstall = false;
      this.deferredPrompt = null;
    },

    async installApp() {
      if (!this.deferredPrompt) return;

      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;

      this.deferredPrompt = null;
      // this.canInstall = false;

      if (outcome === "accepted") {
        this.$emit("installed");
      } else {
        this.$emit("dismissed");
      }
    },
  },
};
</script>